import { Component, OnInit, Inject, ChangeDetectorRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { API_CONSTANTS } from '../../../constants/API-CONSTANTS';
import { UserService } from '../../../user/services/user.service';
import { combineLatest, skip, Subscription } from 'rxjs';
import { SessionService } from 'src/app/features/http-services/session.service';
import { StorageService } from 'src/app/features/http-services/storage.service';
import { ModalOptions, BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ApiService } from "src/app/features/http-services/api.service";
import { DOCUMENT } from '@angular/common';
import { PermissionsService } from "src/app/features/http-services/permissions.service";
import { SidenavService } from "../../services/sidenav.service";
import { ConfirmationDialogComponent } from "../../../components/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'xchange-site-header',
  templateUrl: './site-header.component.html',
  styleUrl: './site-header.component.scss'
})
export class SiteHeaderComponent  {
  menuLeft: Array<any> = [];
  menuRight: Array<any> = [];
  accountInfo: any = '';
  cartCount: any = 0;
  cartData: any;
  project: string = '';
  profileChanges!: Subscription;
  currentUserInfo: any = {};
  url: string = '';
  uidSubject!: Subscription;
  userSubject!: Subscription;
  userInfo: any;
  uid: any;
  displayCustomerNumber: any;
  displayCustomerAddress: any;
  uidSub!: Subscription;
  miniCartSub!: Subscription;
  @Output() exitEvent = new EventEmitter();
  selectedAccountSubject!: Subscription;
  clearunitSubject!: Subscription;
  selectedAccountData: any = "";
  logoType: string = "residential";
  logo: string = "";
  accountInfoSet = false;
  accountActiveStateSub!: Subscription;
  salesAccountSelected = false;
  isSalesPerson = false;
  isSalesOps = false;
  isBuilderXchnage: boolean = false;
  accountDropdownItems: Array<any> = [];
  salesManRole:any;
  modalRef!: BsModalRef;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private cd: ChangeDetectorRef,
    public storageService: StorageService,
    private userService: UserService,
    private router: Router,
    private sessionService: SessionService,
    private ar: ActivatedRoute,
    private sideNav: SidenavService,
    private permissionService: PermissionsService,
    private apiService: ApiService,
    private modalService: BsModalService,
  ) {
    this.clearunitSubject = this.storageService.triggerClearUnit.subscribe(rs=>{
      this.userService.clearB2BUnit().subscribe(() => {
        localStorage.setItem("customerAddress", "");
        this.navigateToSalesAccounts();
      });
      this.exitEvent.emit();
    })
    this.profileChanges = this.userService.currentUserDetails.subscribe(
      (data: any) => {
        if (data != null) {
          this.isBuilderXchnage = data?.body?.orgUnit?.builderMigrated;
          const commercialMenu = {
            name: 'Mohawk Group',
            link: '/commercial',
            linkWithCustomer: '/commercial/account/search',
            isActive: true,
            menuName: 'commercial',
          };
          const resedentialMenu = {
            name: 'Mohawk Flooring',
            link: '/residential',
            linkWithCustomer: '/residential/account/search',
            isActive: true,
            menuName: 'residential',
          };
          if (data?.body?.isSalesPerson == true) {
            if (
              data?.body?.salesPersonAvailableSites?.length == 1 &&
              data?.body?.salesPersonAvailableSites != undefined
            ) {
              if (data?.body?.salesPersonAvailableSites[0] == "R") {
                this.menuLeft = [resedentialMenu];
              }
              if (data?.body?.salesPersonAvailableSites[0] == "C") {
                this.menuLeft = [commercialMenu];
              }
            } else {
              //this.menuLeft = [resedentialMenu, commercialMenu];
              this.menuLeft = [resedentialMenu]
            }
          } else if (
            data?.body?.accounts?.length > 0 &&
            data?.body.isCSR == false &&
            data?.body.isFinancialSuperAdmin == false &&
            data?.body.isFinancialUser == false &&
            data?.body.isIsAdmin == false
          ) {
            const index1 = data?.body?.accounts.findIndex(
              (a: any) => a.company == "R"
            );
            const index2 = data?.body?.accounts.findIndex(
              (b: any) => b.company == "C"
            );
            this.menuLeft = [];
            if (index1 > -1) {
              this.menuLeft.push(resedentialMenu);
            }
            if (index2 > -1) {
              this.menuLeft.push(commercialMenu);
            }
          } else {
            //this.menuLeft = [resedentialMenu, commercialMenu];
            this.menuLeft = [resedentialMenu]
          }
          if (this.menuLeft.length == 1) {
            this.project = this.menuLeft[0]?.linkWithCustomer;
            this.userService.setEnvironment(this.menuLeft[0].menuName);
          }
          
        }
        this.currentUserInfo = data?.body;
        this.salesManRole = data?.body?.salesManRole;
        if(this.salesManRole == "TEAM"){
          this.salesManRole = "TM"
        }else if(data?.body?.isSalesOps){
          this.salesManRole = 'SalesOps';
        }

        localStorage.setItem('uid', data?.body?.uid);
        localStorage.setItem('customerName', data?.body?.name);
        this.getDataFromLocal();
      }
    );
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = this.router.url;
      }
    });
    this.url = this.router.url;
    this.project = this.ar.snapshot.data['project'];
    this.logoType = this.project;
    this.miniCartSub = this.storageService
      .getItem("miniCartCount")
      .subscribe((result) => {
        this.cartCount = result?.totalItems || 0;
        this.cartData = result;
      });
    this.uidSub = this.storageService.getItem("uid").subscribe((res) => {
      this.accountInfo = res;
    });
    this.accountActiveStateSub = combineLatest([
      this.userService.accountInfoSet,
      this.userService.isCSR,
      this.userService.isSalesPerson,
      this.userService.isSalesOps,
      this.userService.isCustomer,
      this.userService.isFinancialSuperAdmin,
      this.userService.isFinancialUser,
      this.userService.isMultiAccountCustomer,
      this.userService.isIsAdmin,
    ]).subscribe(
      ([
        accountInfo,
        isCSR,
        isSalesPerson,
        isSalesOps,
        isCustomer,
        isFinancialSuperAdmin,
        isFinancialUser,
        isMultiAccountCustomer,
        isIsAdmin,
      ]) => {
        if (
          isCSR ||
          isCustomer ||
          isFinancialSuperAdmin ||
          isFinancialUser ||
          isMultiAccountCustomer ||
          isIsAdmin
        ) {
          this.accountInfoSet = accountInfo;

          if (isCustomer) {
            const moduleName = this.url.includes("commercial") ? "C" : "R";
            this.accountInfoSet =
              this.currentUserInfo?.accounts?.filter(
                (item: any) => item.company === moduleName
              ).length > 0 && !this.url.includes("multi-account");
          }
        } else {
          this.accountInfoSet = true;
          if (isSalesPerson) {
            this.isSalesPerson = true;
            this.salesAccountSelected = accountInfo;
          }
          if (isSalesOps) {
            this.isSalesOps = true;
          }
        }

        this.project = this.ar.snapshot.data["project"];
        this.setAccountDropdown(this.project);
        this.logoType = this.project;
        if (isSalesPerson && this.project === "residential") {
          this.accountDropdownItems = this.accountDropdownItems.filter(
            (item: any) => item.name !== "Mohawk Sales Team"
          );
        }

        if(this.currentUserInfo?.isResidentialManager){
          this.accountDropdownItems = this.accountDropdownItems.filter(
            (item: any) => (item.name !== "Entitlement Manager" && item.name !== "Sample Budget")
          );
        }
        if(this.currentUserInfo?.isALCBDM){
          this.accountDropdownItems = this.accountDropdownItems.filter(
            (item: any) => (item.name !== "Entitlement Manager")
          );
        }
        
      }
    );
    
    this.changeFavIcon();
    this.cd.detectChanges();
    this.getCartDetails();
    this.userService.userAddress.subscribe((res) => {
      localStorage.setItem('customerAddress', res);
      this.getDataFromLocal();
    });
    this.selectedAccountSubject = this.storageService
      .getselectedAccount()
      .subscribe((res: any) => {
        if (res == null || this.selectedAccountData === res) {
          return;
        }
        this.selectedAccountData = res;
        if (res) {
          this.getCartDetails();
        }
      });
  }

  setAccountDropdown(project: string) {
    this.accountDropdownItems = this.permissionService.getProfileDropdown(
      (this.isSalesPerson || this.isSalesOps) ? this.salesAccountSelected : this.accountInfoSet,
      project
    );
  }
  accountData: any;

  getCartDetails() {
    if (this.uidSubject) {
      this.uidSubject.unsubscribe();
    }
    if (this.userSubject) {
      this.userSubject.unsubscribe();
    }
    this.uidSubject = this.storageService
      .getItem('uid')
      .subscribe((res: any) => {
        this.uid = res;
      });
    if (this.uid == undefined) {
      return;
    }
    if (this.uidSubject) {
      this.uidSubject.unsubscribe();
    }
    this.userSubject = this.storageService
      .getItem('userInfo')
      .subscribe((res: any) => {
        if (res) {
          this.userSubject.unsubscribe();
          let url = API_CONSTANTS.miniCart.replace(
            '{customerNumber}',
            this.uid
          );
          url = url.replace('{uid}', res?.uid);

          this.apiService.getMiniCartData(`${url}`).subscribe({
            next: (result: any) => {
              this.storageService.setItem('miniCartCount', result);
              this.cartCount = result?.totalItems || 0;
            },
            error: (error: any) => {
              this.cartCount = 0;
              this.storageService.setItem('miniCartCount', '');
            },
          });
        }
      });
  }

  setActive(menuName: string) {
    let className = '';
    const path: any = this.router.url.split('?');
    if (path[0].includes(menuName)) {
      className = 'active';
    }
    return className;
  }

  logout() {
    this.sessionService.logout();
  }

  changeFavIcon() {
    const favIcon = this.document.getElementById('appFavicon');
    if (this.project === 'residential') {
      favIcon?.setAttribute('href', '/assets/images/icons/residential-favicon.ico');
    } else {
      favIcon?.setAttribute('href', '/assets/images/icons/residential-favicon.ico');
    }
    this.cd.detectChanges();
  }

  setEnvironment(menu: any) {
    this.userService.setEnvironment(menu.menuName);
  }

  getDataFromLocal() {
    if (this.menuRight.length > 1) {
      this.menuRight[2] = {
        name:
          localStorage.getItem("customerAddress") == "undefined" ||
          localStorage.getItem("customerAddress") == undefined
            ? ""
            : localStorage.getItem("customerAddress"),
        isShow: this.setExitItem(),
      };
    }
    if (this.currentUserInfo == undefined) {
      return;
    }
    this.setLogo(this.currentUserInfo?.orgUnit?.name || '');
    if (this.currentUserInfo) {
      if (
        this.currentUserInfo.orgUnit?.uid == ' ' ||
        this.currentUserInfo.orgUnit?.uid == undefined ||
        this.currentUserInfo.orgUnit?.uid == null
      ) {
        this.displayCustomerNumber = 'EMPTY_B2BUNIT';
        localStorage.setItem('customerAddress', '');
      } else {
        this.displayCustomerNumber = isNaN(
          this.currentUserInfo.orgUnit?.uid.split('_')[0]
        )
          ? this.currentUserInfo.orgUnit?.uid
          : this.currentUserInfo.orgUnit?.uid.split('_')[0] * 1;
      }
    } else {
      this.displayCustomerNumber = localStorage.getItem('accountNumber');
    }

    this.displayCustomerAddress = localStorage.getItem('customerAddress');
    this.menuRight = [
      {
        name:
          this.currentUserInfo?.isCSR === true ||
          this.currentUserInfo?.isSalesPerson === true ||
          this.currentUserInfo?.isSalesOps === true
            ? this.currentUserInfo?.orgUnit?.name
            : localStorage.getItem("customerName"),
        icon: this.currentUserInfo?.isCSR === true ? false : true,
        link: "",
      },
      {
        name: this.displayCustomerNumber,
      },
      {
        name:
          localStorage.getItem("customerAddress") == "undefined" ||
          localStorage.getItem("customerAddress") == undefined
            ? ""
            : this.displayCustomerAddress,
        isShow: this.setExitItem(),
      },
    ];
  }

  salesDashboardClick() {
    if (
      this.storageService.userInfo?.orgUnit.inHouseAccount === false &&
      (this.storageService.userInfo?.isSalesPerson === true ||
        this.storageService.userInfo?.isSalesOps === true || this.storageService.userInfo?.isALCBDM === true || this.storageService.userInfo?.isResidentialManager === true)
    ) {
      this.exitClick();
    } else {
      this.router.navigateByUrl(this.logoType + "/salesperson");
    }
  }

  private setLogo(name: any) {
    if (name != null) {
      let index = name.indexOf(" ");
      this.logo = name.substring(0, 1) + name.substring(index + 1, index + 2);
    }
  }

  setExitItem() {
    const module = this.url.includes("commercial") ? "C" : "R";
    if (
      this.storageService.userInfo?.isCSR ||
      this.storageService.userInfo?.isFinancialSuperAdmin ||
      this.storageService.userInfo?.isFinancialUser ||
      this.storageService.userInfo?.isIsAdmin ||
      (this.storageService.userInfo?.isCustomer &&
        this.currentUserInfo?.accounts?.filter(
          (item: any) => item.company === module
        ).length > 1 &&
        !this.url.includes("multi-account"))
    )
      return true;
    return false;
  }

  navigateToUserSearch() {
    const baseUrlPath = this.router.url.split('?')[0].includes('commercial')
      ? 'commercial'
      : 'residential';
    this.storageService.clear();
    localStorage.setItem("isSampleOrderFlow", "false");
    sessionStorage.removeItem("tabId");
    this.userService.setAccountInfoState(false);
    this.menuRight[1].name = "";

    this.getDataFromLocal();
    localStorage.setItem('customerAddress', 'Test123 123 ...12345');
    this.userService.clearB2BUnit().subscribe(() => {
      if (!this.currentUserInfo?.isCustomer) {
        this.router.navigate(['/' + baseUrlPath + '/account/search']);
      } else {
        this.router.navigate(['/' + baseUrlPath + '/account/multi-account']);
      }
    });
   
    this.exitEvent.emit(true);
  }

  navigateToSalesAccountsInCaseOfInhouseAccount(uid: any) {
    this.storageService.setItem("userInfo", null);
    this.userService.setUnit("?unitUid=" + uid).subscribe((res) => {
      this.userService.setAccountInfoState(false);
      this.storageService.setselectedAccount(null);
      this.userService.currentUserDetails.next(null);
      const baseUrlPath = this.router.url.split("?")[0].includes("commercial")
        ? "commercial"
        : "residential";
      this.router.navigate(["/" + baseUrlPath + "/salesperson"]);
    });
  }

  getLogoRouterLink(){
    let routerLink = '/' + this.logoType;
    if( this.storageService.userInfo?.isALCBDM || this.storageService.userInfo?.isResidentialManager || this.storageService.userInfo?.isSalesPerson|| this.storageService.userInfo?.isSalesOps){
      routerLink = '/' + this.logoType+'/salesperson';
    }
    return routerLink;
  }

  navigateToSalesAccounts(navigateTo:any = '') {
    this.userService.setUnit("").subscribe((res) => {
      this.userService.setAccountInfoState(false);
      this.storageService.setselectedAccount(null);
      this.userService.currentUserDetails.next(null);
      const baseUrlPath = this.router.url.split("?")[0].includes("commercial")
        ? "commercial"
        : "residential";
      if(navigateTo){
        this.router.navigate(["/" + baseUrlPath + "/salesperson/view-accounts"]);
      }else{
         this.router.navigate(["/" + baseUrlPath + "/salesperson"]);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userInfo) {
      this.userInfo.unsubscribe();
    }
    if (this.selectedAccountSubject) {
      this.selectedAccountSubject.unsubscribe();
    }
    this.profileChanges.unsubscribe();
    this.uidSub.unsubscribe();
    this.miniCartSub.unsubscribe();
    this.accountActiveStateSub.unsubscribe();
    if (this.uidSubject) {
      this.uidSubject.unsubscribe();
    }
    if (this.userSubject) {
      this.userSubject.unsubscribe();
    }
    if(this.clearunitSubject){
      this.clearunitSubject.unsubscribe();
    }
  }

  navigateToCart() {
    if(this.project.includes("residential")){
      this.router.navigate(["/residential/cart"]);
    }
    else if (this.project === "residential") {
      this.router.navigate(["/residential/cart"]);
    } else if (this.project === "commercial" && !this.cartData.isQuote) {
      this.router.navigate(["/commercial/cart"]);
    } else if (this.project === "commercial" && this.cartData.isQuote) {
      if (this.cartData.quoteStatus === "BUYER_DRAFT") {
        this.router.navigateByUrl(
          "/commercial/quotes/request-quote/" + this.cartData?.quoteNumber
        );
      } else {
        this.router.navigate(["/commercial/cart"]);
      }
    }else if (this.project.includes("commercial")) {
      this.router.navigate(["/commercial/cart"]);
    }
  }

  navigateToHome(){
    let url = `${this.logoType}/account/choose-menu`;
    this.router.navigateByUrl(url);
  }

  exitClick(navigateTo:any = '') {
    if (this.cartCount > 0) {
      this.handleCartValidation();
    } else {
      if (
        this.storageService?.userInfo?.isSalesPerson &&
        this.storageService?.userInfo?.orgUnit?.inHouseAccount
      ) {
        this.navigateToSalesAccountsInCaseOfInhouseAccount(
          this.storageService?.userInfo?.orgUnit?.uid
        );
      } else {
        this.navigateToSalesAccounts(navigateTo);
      }
    }
  }

  handleCartValidation() {
    this.openConfirmationModal({
      title: "Did you forget something?",
      content: `The below account has existing items in the cart which will be removed.
      (${this.displayCustomerNumber})`,
      primaryActionLabel: "Continue",
      secondaryActionLabel: "Cancel",
      onPrimaryAction: () => {
        this.clearCart();  
      },
      onSecondaryAction: () =>{ this.modalService.hide("cartValidationConfirmation")},
    });
  }

  openConfirmationModal(data = {}) {
    const initialState: ModalOptions = {
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: {
        ...data,
      },
    };
    this.modalRef = this.modalService.show(
      ConfirmationDialogComponent,
      Object.assign(initialState, {
        id: "cartValidationConfirmation",
        class: "modal-md modal-dialog-centered",
        backdrop: "static",
        keyboard: false,
      })
    );
  }

  clearCart(){
    this.userService.cancelCart(this.cartData?.code || "123456").subscribe(res =>{
      this.modalService.hide("cartValidationConfirmation");
      this.storageService.setItem("miniCartCount", "");
      this.navigateToSalesAccounts();
    })
  }

  showMenu() {
    this.sideNav.show();
  }

}
